/**
 * Ayuda — Compras → Remitos
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PUR_REMITS_ITEM = {
  id: 'remits',
  screenId: 'adm-pur-remits',
  label: 'Remitos',
  description: 'Registrá remitos de compra recibidos de proveedores.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Acá cargás los remitos que te entrega un proveedor cuando recibís mercadería. Queda registrado qué productos entraron, en qué cantidad y de quién. Después podés facturar lo recibido o vincular el remito a una factura del proveedor.',
      },
      {
        title: 'Paso 1 — Buscar remitos',
        fields: [
          {
            label: 'Fecha Desde / Fecha Hasta',
            description: 'Filtrá por el período en que se registraron los remitos.',
          },
          {
            label: 'Proveedor',
            description: 'Elegí un proveedor para ver solo sus remitos.',
          },
          {
            label: 'Buscar',
            description: 'Actualiza la lista.',
          },
        ],
      },
      {
        title: 'Paso 2 — Leer la lista',
        bullets: [
          'Fecha, Proveedor, Número (punto de venta y número del comprobante) y Observaciones.',
          'Ícono de cruz (×) — eliminar el remito.',
        ],
        paragraphs: [
          'Tocá una fila para ver el detalle. No hay edición: si hay un error, eliminá y cargá de nuevo.',
        ],
      },
      {
        title: 'Paso 3 — Cargar un remito nuevo',
        intro: 'El botón + abre «Remito de Proveedores».',
      },
      {
        title: 'Encabezado',
        fields: [
          { label: 'Fecha', description: 'Fecha del remito. Obligatoria.' },
          { label: 'Tipo de remito', description: 'Elegí el tipo configurado para compras.' },
          { label: 'Centro / Número', description: 'Punto de venta y número del comprobante del proveedor.' },
          { label: 'Proveedor', description: 'Buscá y elegí quién te entregó la mercadería. Obligatorio.' },
          {
            label: 'Moneda',
            description:
              'Aparece al elegir el tipo de remito. Las opciones son las habilitadas para ese comprobante en Configuración → Comprobantes, igual que en las facturas. Si cargás un precio, la moneda es obligatoria.',
          },
        ],
      },
      {
        title: 'Crear desde factura',
        intro:
          '«Crear desde Factura» busca facturas del proveedor que tienen productos pendientes de recibir. Elegís la factura y el sistema carga las líneas con las cantidades. Sirve cuando ya registraste la factura y ahora anotás la recepción física.',
      },
      {
        title: 'Líneas del remito',
        fields: [
          { label: 'Producto', description: 'Artículo recibido. Obligatorio en cada línea.' },
          { label: 'Cantidad', description: 'Cuántas unidades entraron. Obligatoria.' },
          {
            label: 'Precio',
            description:
              'Opcional, en la moneda del remito. Si lo cargás, al crear la factura desde este remito el precio se convierte a la moneda de la factura. Si lo dejás vacío, lo completás en la factura.',
          },
          {
            label: 'Almacén',
            description:
              'Si el producto lleva stock, el sistema puede pedir en qué depósito se guarda (cuando hay más de un almacén).',
          },
          { label: 'Botón +', description: 'Agrega una descripción extra opcional a la línea.' },
          { label: 'Botón x', description: 'Quita la línea.' },
          { label: 'Agregar línea', description: 'Sumá otro producto.' },
        ],
        paragraphs: [
          'Si la línea viene de una factura, puede mostrarse el comprobante de origen al lado.',
        ],
      },
      {
        title: 'Observaciones y confirmar',
        fields: [
          { label: 'Observaciones', description: 'Notas generales (opcional).' },
          { label: 'Limpiar formulario', description: 'Borra todo para cargar otro remito.' },
          { label: 'Confirmar', description: 'Guarda el remito y actualiza el stock de los productos stockeables.' },
        ],
      },
      {
        title: 'Ver el detalle',
        bullets: [
          'Tipo, número, fecha y datos del proveedor.',
          'Productos: código, descripción, cantidad recibida y «Sin Facturar» (en rojo si falta imputar algo a una factura).',
          'Observaciones y quién lo creó o modificó.',
        ],
      },
      {
        title: 'Eliminar un remito',
        intro:
          'Desde la lista (cruz) o desde el detalle («Eliminar remito»). Al confirmar con «SI», se borra el comprobante y se revierten los movimientos de stock.',
      },
    ],
  },
}
